import { render, staticRenderFns } from "./WizardContentRadioSelectorOption.vue?vue&type=template&id=7246bf0e&scoped=true&"
import script from "./WizardContentRadioSelectorOption.vue?vue&type=script&lang=ts&"
export * from "./WizardContentRadioSelectorOption.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentRadioSelectorOption.vue?vue&type=style&index=0&id=7246bf0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7246bf0e",
  null
  
)

export default component.exports